import { Link } from "react-router-dom";
import ManageTeamCard from "../../components/common/manageTeamCard";
import Back from "../../assets/icons/back.svg";
import InviteMemberCard from "../../components/common/inviteMemberCard";

const EditMember = () => {
  return (
    <div className="grid gap-2 space-x-3 w-full">
      <div className="flex pt-3 pl-3">
        <Link to="/main/manage-team">
          <div className="flex items-center">
            <img src={Back} alt="Edit Icon" className="mr-1" />
            <span className="text-lg font-bold text-black ml-1">
              Edit Member
            </span>
          </div>
        </Link>
      </div>
      <div>
        <ManageTeamCard
          member="Allsion Press"
          email="allisonpr@carfixtop.com"
          phone="555-788-2719"
        />
      </div>
      <InviteMemberCard buttonTitle="Save" buttonType="save" />
    </div>
  );
};
export default EditMember;
